// "Yeni bir sürüm hazır · Yenile" (Phase 11 PWA update flow): one persistent toast when lib/sw.ts reports a waiting
// service worker; the action activates it and reloads (applySwUpdate). Mounted in the entry for every screen, so
// the `mobile` namespace is only requested once an update is actually waiting.
// i18n-own-suspense: mobile
import { Suspense, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '@moods/ui';
import { applySwUpdate, useSwUpdate } from '../../lib/sw';

export function PwaUpdateToast() {
  const waiting = useSwUpdate(s => s.waiting);
  if (!waiting) return null;
  return (
    <Suspense fallback={null}>
      <UpdateToast />
    </Suspense>
  );
}

function UpdateToast() {
  const { t } = useTranslation('mobile');
  const { toast } = useToast();
  useEffect(() => {
    toast({
      id: 'pwa-update',
      tone: 'info',
      title: t('pwa.updateTitle'),
      sub: t('pwa.updateBody'),
      duration: 0,
      action: { label: t('pwa.reload'), onClick: () => applySwUpdate() },
    });
  }, [toast, t]);
  return null;
}
